// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

import { Helper } from '../../../../components';


const BenefitsBlock = ({ classes, images }) => {
  return (
    <div className={classes.mainContainer}>
      {images.map(el => <Helper title={el.title} file={el.image} description={el.description} />)}
    </div>
  );
};

BenefitsBlock.propTypes = {
  classes: PropTypes.object,
  images: PropTypes.array,
};

BenefitsBlock.defaultProps = {
  classes: {},
  images: [],
};


export default withStyles(styles)(BenefitsBlock);
